module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "ch4"
    }
  }), _c('em', [_vm._v("Curve")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Freezeburn forms whirlpools and bearfur has curve.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My line is gravity’s")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("sheer vertical.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Memory’s the same")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("seme. Sail a memo")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("down: there’s the spooled")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("real: plunge into simulcast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Caught up in the network is")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a blue planet, spinner par")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("excellence.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("It’s too small.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Throw it back.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-182a479e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter04.vue
// module id = 93
// module chunks = 0